import { timezoneDayjs as dayjs } from '@travel/traveler-core/utils/jrdpHelper';

export const isInDisplayedPeriod = (startTime?: string, endTime?: string) => {
  const today = dayjs();
  let shouldBeDisplayed = true;

  if (startTime && endTime) {
    shouldBeDisplayed =
      today.isSameOrAfter(dayjs(startTime)) && today.isSameOrBefore(dayjs(endTime));
  } else if (startTime) {
    shouldBeDisplayed = today.isSameOrAfter(dayjs(startTime));
  } else if (endTime) {
    shouldBeDisplayed = today.isSameOrBefore(dayjs(endTime));
  }

  return shouldBeDisplayed;
};
